import { servicePost } from "./client.ts";

export interface CurrencyInfo {
  ID: number;
  From_To: string;
  CurrencyFrom: string;
  CurrencyTo: string;
  CurrentRate: number;
  CurrentAsOf: string;
  PreviousMonthRate: number;
  PreviousMonthAsOf: string;
}

export function getCurrencyInfo() {
  return servicePost<CurrencyInfo[]>("GetCurrencyInfo", {});
}

export interface CustomerSuperSearchResult {
  UserID: number;
  GivenName: string;
  FamilyName: string;
  Email: string;
  Cards: CustomerCard[];
}

export interface CustomerCard {
  FirstSix: string;
  LastFour: string;
  ExpirationDate: string;
  CardHash: string;
}

export function customerSuperSearch(query: string, limit: number) {
  return servicePost<CustomerSuperSearchResult[]>("CustomerSuperSearch", { query, results: limit });
}

export interface BlockCheckPayload {
  CardName: string;
  CardFirstSix: string;
  CardLastFour: string;
  CardHash: string;
  DiscRent: number;
  DiscReturn: number;
  Check_Name: boolean;
  Check_CardHash: boolean;
  Check_CardNumber: boolean;
  Check_FullServerBlock: boolean;
}

export interface BlockCheckResult {
  Name: string;
  Status: string;
  Details: string;
}

/** The server's single parameter is `checkData`, so the payload nests rather than
 *  spreading — sent flat it arrived as `Nothing` and the call faulted on the first
 *  field read. */
export function customerBlockCheckFull(payload: BlockCheckPayload) {
  return servicePost<BlockCheckResult[]>("CustomerBlockCheck", { checkData: payload });
}

/** Fetch the rendered HTML body of a sent email. Server resolves the row
 *  via the encrypted Email_Log DB → S3 → Customer_EmailLog.sMsgBody chain. */
export function getEmailContent(transactionID: number, emailLogID: number) {
  return servicePost<string>("WebGetEmailContent", { transactionID, emailLogID });
}

export interface ValidEmailAddress {
  AddressID: number;
  Email: string;
}

export interface ResendEmailInfo {
  CustomerEmail: string;
  DefaultSenderEmail: string;
  DefaultSenderName: string;
  ValidatedEmailSenders: ValidEmailAddress[];
}

export function getResendEmailInfo(transactionId: number) {
  return servicePost<ResendEmailInfo>("WebGetResendEmailInfo", { transactionId });
}

export function resendEmail(emailLogId: number, transactionId: number, sendTo: string, subject: string, sendAs: string, senderId: number) {
  return servicePost<boolean>("WebResendEmail", { emailLogId, transactionId, sendTo, subject, sendAs, senderId });
}
